import { c as _c } from "react/compiler-runtime";
import { faLineChart } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Tooltip } from '@xefi/x-react/tooltip';
import { useRouter } from 'next/navigation';
import { useTranslation } from 'react-i18next';
import type { SurveyHome } from '@/models/survey';
import type { SurveyTab } from '@/store/mainSlice';
import { SURVEY_STATUS } from '@/utils/constants';
import { SURVEY_TABS } from '@/utils/surveyTabUtils';
type ShowStatisticsProps = {
  survey: SurveyHome;
  setSurveyTab: (value: SurveyTab) => void;
};
export const ShowStatistics = t0 => {
  const $ = _c(7);
  const {
    survey,
    setSurveyTab
  } = t0;
  const {
    t
  } = useTranslation();
  const router = useRouter();
  let t1;
  if ($[0] !== router || $[1] !== setSurveyTab || $[2] !== survey.id || $[3] !== survey.status.label || $[4] !== survey.type || $[5] !== t) {
    t1 = survey.status.label === SURVEY_STATUS.DRAFT ? <button className="flex size-8 cursor-not-allowed items-center justify-center rounded-md opacity-40" disabled={true} onClick={_temp}><FontAwesomeIcon size="lg" icon={faLineChart} /></button> : <Tooltip content={t("result.stats")} placement="top" size="sm" trigger={<button className="flex size-8 cursor-pointer items-center justify-center rounded-md transition-colors" onClick={event_0 => {
      event_0.stopPropagation();
      setSurveyTab(SURVEY_TABS.STATISTICS);
      const params = new URLSearchParams();
      if (survey.type?.slug) {
        params.set("type", survey.type.slug);
      }
      params.set("sId", survey.id);
      router?.push(`/survey?${params.toString()}`);
    }}><FontAwesomeIcon size="lg" icon={faLineChart} /></button>} />;
    $[0] = router;
    $[1] = setSurveyTab;
    $[2] = survey.id;
    $[3] = survey.status.label;
    $[4] = survey.type;
    $[5] = t;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  return t1;
};
function _temp(event) {
  return event.stopPropagation();
}